import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../../utils/api';

const initialState = {
    data: null,
    isLoading: true,
    error: null
};

export const fetchCustomerData = createAsyncThunk('data/fetchCustomerData', async () => {
    try {
        const response = await apiRequest('get', 'customers');
        return response;
    } catch (error) {
        throw error?.response?.data?.message || error?.response?.data || error?.message;
    }
});

const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomerData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchCustomerData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.error = null;
                state.data = action.payload?.data;
            })
            .addCase(fetchCustomerData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error;
            });
    }
});

export default customerSlice.reducer;
